<!--
Postcard
明信片
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="明信片" name="明信片">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in postcard"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="postcardFormActive">
              <PvcPostcard v-if="postcard[0].status"/>
              <PaperPostcard v-if="postcard[1].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import PvcPostcard from "./Postcard/PvcPostcard.vue";
import PaperPostcard from "./Postcard/PaperPostcard.vue";

export default {
  name: "Postcard",
  methods: {},
  components: {
    PvcPostcard,
    PaperPostcard
  },
  data() {
    return {
      forcollapse: ['PVC明信片','纸质明信片'],
      postcard: [
        { id: "PvcPostcard", name: "PVC明信片", status: false },
        { id: "PaperPostcard", name: "纸质明信片", status: false }
      ],
      postcardFormActive: []
    };
  }
};
</script>
<style scoped>
</style>